import PayPal from '../../../modules/paypal/paypal';
import { addApplePayButton } from 'vendors/applepay';

define([
  "globals",
  "jquery",
  "knockout",
  "feature!colorbox-confirm",
  "colorbox-message",
  "cookies-factory",
  "js-cookie",
  "colorbox"],
  function (globals, $, ko, ColorboxConfirm, ColorboxMessage, cookiesFactory, Cookies) {

    "use strict";

    return function MixedCartViewModel() {

      var self = this;
      self.isMobile = ko.computed(function () {
        var isMobile = globals.ssm.getState("mobile").options.observableIsActive();
        return isMobile;
      });

      self.isDesktop = ko.computed(function () {
        return globals.ssm.getState("desktop").options.observableIsActive();
      });

      self.isTablet = ko.computed(function () {
        return globals.ssm.getState("tablet-only").options.observableIsActive();
      });

      self.measureProductId = 502796;
      self.installProductId = 502797;
      self.hideStatisfactionGuarantee = ko.observable(self.isMobile() ? true : false);
      self.lineItemsSelected = ko.observable(0);
      self.shouldShowLearnMore = ko.observable(self.isMobile() ? true : false);
      self.promoCode = ko.observable();
      self.selectedLineItems = ko.observableArray();
      self.showCosts = ko.observable(true);
      self.hideUnitPrice = ko.observable(false);
      self.isSubmitting = ko.observable(false);
      self.isApplyingPromo = ko.observable(false);

      if (globals.error &&
        globals.error.message &&
        globals.error.message.length > 0) {
        var uri = window.location.toString();
        if (uri.indexOf("?") > 0) {
          var clear_uri = uri.substring(0, uri.indexOf("?"));
          window.history.replaceState({}, document.title, clear_uri);
        }
        var colorboxConfirm = new ColorboxMessage({
          title: globals.error.title,
          msg: globals.error.message,
          cssClass: "bdc-colorbox-confirm-deletion",
          buttons: {
            ok: {
              text: "OK"
            },
          }
        }, function () {
          globals.error = null;
          return true;
        });
      };

      if (globals.isEstimatesFeatureEnabled && !globals.isInternalUser && !globals.isAuthenticated) {
        document.addEventListener('loginStatusChange', (e) => onLoginStatusChange(e, ''));
      }

      if (self.isMobile) {
        var gccSelectAll = document.getElementById('gcc-select-all-label');
        var gccQtyPlus = document.querySelectorAll('.gcc-qty-btn-plus');
        var gccQtyMinus = document.querySelectorAll('.gcc-qty-btn-minus');
        var gccDeleteCan = document.querySelectorAll('.gcc-delete-can');

        if (gccSelectAll) {
          gccSelectAll.innerHTML = "Select All Items";
        }
        if (gccQtyPlus) {
          gccQtyPlus.forEach(element => {
          element.innerHTML = "<svg width=\"10\" height=\"9\" viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
              "                    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z\" fill=\"black\"/>\n" +
              "                  </svg>"
          })
        }
        if (gccQtyMinus) {
          gccQtyMinus.forEach(element => {
            element.innerHTML = "<svg width=\"10\" height=\"10\" viewBox=\"0 0 14 2\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
              "                    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14 2H0V0H14V2Z\" fill=\"black\"/>\n" +
              "                  </svg>"
          })
        }
        if (gccDeleteCan) {
          gccDeleteCan.forEach(element => {
            element.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"25\" height=\"25\" viewBox=\"0 0 32 32\" fill=\"none\">\n" +
              "                  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.00008 25.3333C8.00008 26.8 9.20008 28 10.6667 28H21.3334C22.8001 28 24.0001 26.8 24.0001 25.3333V9.33333H8.00008V25.3333ZM25.3334 5.33333H20.6667L19.3334 4H12.6667L11.3334 5.33333H6.66675V8H25.3334V5.33333Z\" fill=\"black\"/>\n" +
              "                </svg>"
          })
        }
      };

      self.stickyScroll = () => {
        if (self.isMobile) {
          var summaryElement = document.getElementById('order-summary-section');
          var mobileSummaryElement = document.getElementById('mobile-sticky-checkout');

          if (summaryElement === null || mobileSummaryElement === null) {
            return;
          }

          var summaryTop = summaryElement.getBoundingClientRect().top;
          summaryTop = summaryTop > summaryElement.offsetTop ? summaryTop : summaryElement.offsetTop;

          var diff = summaryTop - document.documentElement.scrollTop;
          var deadpoolOffset = 500;
          if (diff < deadpoolOffset)
          {
            mobileSummaryElement.classList.add('dn');
          } else {
            mobileSummaryElement.classList.remove('dn');
          }
        }
      };

      self.registerScroll = () => {
        const isBC = globals.siteId === 3;
        if (isBC) {
          document.removeEventListener("scroll", self.stickyScroll);
          document.addEventListener("scroll", self.stickyScroll);
        }
      }

      self.promoCode.subscribe(function () {
        $(".field-validation-error").hide();
      });

      self.hasCandidatePromo = ko.computed(function () {
        return (self.promoCode() !== undefined && self.promoCode().length > 0);
      });

      self.enableSubmit = ko.computed(function () {
        return (self.hasCandidatePromo() && !self.isApplyingPromo());
      });

      self.toggleIsLineItemSelected = function (data, e) {
        var index = self.selectedLineItems.indexOf(e.target.value);
        if (self.selectedLineItems.indexOf(e.target.value) === -1) {
          self.selectedLineItems.push(e.target.value);
        }
        else {
          self.selectedLineItems.remove(e.target.value);
        }

        var selectAllShouldBeChecked = $(".bdc-cart-item-select-col input[type=checkbox]:not(:checked)").length === 0;
        $("#gcc-select-all").prop("checked", selectAllShouldBeChecked ? "checked" : "");
      };

      self.addPaypalButtons = () => {
        // These two checks aren't necessary since there are no other sites with these selectors on thier pages
        const isBC = globals.siteId === 3;
        const isAB = globals.siteId === 1;
        if (isBC || isAB) {
          const paypalMount = document.querySelector('#gcc-cart-paypal-bottom');
          if (paypalMount)
          {
            const paypal = new PayPal();
            paypal.addVerticalButtons('#gcc-cart-paypal-bottom', { tagline: false });
          }
        }
      }

      // Only acts when the server rendered the Apple Pay placeholder (Blinds.com, admin setting AND tester flag), and
      // never throws, so PayPal and the rest of every cart render always run.
      self.addApplePayButton = () => addApplePayButton({ globals });

      // The cart summary HTML is re-rendered from the server after cart changes, so every express button is re-added.
      self.addExpressPayButtons = () => {
        self.addPaypalButtons();
        self.addApplePayButton();
      };

      self.updateAffirm = () => {
        if (window.affirm && window.affirm.ui) {
          window.affirm.ui.ready(function () {
            window.affirm.ui.refresh();
          });
        }
      };

      self.whenPromoApplied = function (data) {
        self.isApplyingPromo(false);
        const isBC = globals.siteId === 3;
        self.promoCode('');
        ko.cleanNode(document.querySelector('.bdc-cart'));
        $('.bdc-cart-wrapper').html(data);
        ko.applyBindings(self, document.querySelector('.bdc-cart'));
        self.addExpressPayButtons();
        if (isBC) {
          window.renderDeadpoolLineItem();
        }
        self.registerScroll();
      };

      self.reportApplyingSpecificPromo = () => {
        const button = $('.bdc-cart-promo-codes button');
        button.text('Applying Promo...');
      };

      self.reportApplyingPromo = () => {
        const button = $('.bdc-cart-promo-codes-available button');
        button.text('Applying Promo...');
        button.prop('disabled', true);
      };

      self.applyExclusivePromo = (data, event) => {
        var candidatePromoFromEvent = event.target.dataset.promoid;
        self.reportApplyingSpecificPromo();
        $.post('/Ordering/Promo/ApplyExclusive ', {
          promoId: candidatePromoFromEvent,
        }, self.whenPromoApplied);
      };

      self.applyPromo = (promoCode, isSpecificPromo) => {
        self.isApplyingPromo(true);
        if (isSpecificPromo) {
          self.reportApplyingSpecificPromo();
        } else {
          self.reportApplyingPromo();
        }

        self.registerScroll();

        return $.post('/Ordering/Promo/Apply', {
          promoCode,
        }, self.whenPromoApplied).fail(function() {
          self.isApplyingPromo(false);
        });
      };

      self.autoApplyBestPromo = (promoCode) => {
        var bestPromoCode = promoCode || globals.bestAvailablePromo;
        var bestChoicePromos = globals.bestChoicePromos || [];

        var promosToApply = [];

        if (bestChoicePromos && bestChoicePromos.length > 0) {
          promosToApply = promosToApply.concat(bestChoicePromos);
        }

        if (bestPromoCode !== undefined && bestPromoCode !== '' && bestPromoCode !== 'null') {
          if (!promosToApply.includes(bestPromoCode)) {
            promosToApply.push(bestPromoCode);
          }
        }

        if (promosToApply.length > 0) {
          $.post('/Ordering/Promo/ClearAllPromos')
          .then((res) => {
            var combinedPromoCodes = promosToApply.join(',');
            self.applyPromo(combinedPromoCodes, true);
          });
        }
      };

      self.applySuggestedPromo = (data, event) => {
        var candidatePromoFromEvent = event.target.dataset.promocode;
        var candidatePromo = candidatePromoFromEvent ? candidatePromoFromEvent : self.promoCode();
        self.applyPromo(candidatePromo);
      };

      self.applySpecificPromo = () => {
        const candidatePromo = self.promoCode();
        self.applyPromo(candidatePromo, true);
      };

      $('body').on('click', '.bdc-cart-totals-remove-promo', function () {
        // Prevent multiple concurrent remove promo requests
        if (self.isApplyingPromo()) {
          return;
        }
        $('body').addClass('loading');
        $('#gcc-cart-items').addClass('o-30');
        self.isApplyingPromo(true);
        $.post('/Ordering/Promo/Remove', { promoCode: $(this).attr('data-promo-code') }, function (data) {
          $('.bdc-cart-wrapper').html(data);
          self.promoCode('');
          $('body').removeClass('loading');
          $('#gcc-cart-items').removeClass('o-30');
          ko.applyBindings(self, document.querySelector('.bdc-cart'));
          self.addExpressPayButtons();
          if (globals.siteId === 3) {
            window.renderDeadpoolLineItem();
          }
          self.isApplyingPromo(false);
        }).fail(function () {
          $('body').removeClass('loading');
          $('#gcc-cart-items').removeClass('o-30');
          self.isApplyingPromo(false);
        });
      });

      self.fireCartUpdateEvent = function ($cartItem, newQuantity) {
        var eventName = '';
        var originalQuantity = parseInt($cartItem.attr('data-quantity'));

        if (originalQuantity < newQuantity) {
          eventName = 'cart add';
        }
        else {
          eventName = 'cart remove';
        }

        var quantity = Math.abs(originalQuantity - newQuantity)
        var basePrice = (quantity * parseFloat($cartItem.attr('data-base-price'))).toFixed(2);
        var optionPrice = (quantity * parseFloat($cartItem.attr('data-option-price'))).toFixed(2);
        var isRemake = $cartItem.attr('data-is-remake') === 'True';
        var isSample = $cartItem.attr('data-is-sample') === 'True';
        var productType = "product";
        if (isRemake)
          productType = "remake";
        if (isSample)
          productType = "sample";
        var thdAnalyticsEvent = {
          category: {
            primaryCategory: 'cart view modification'
          },
          eventInfo: {
            eventName: eventName
          },
          item: [
            {
              quantity: quantity,
              price: {
                basePrice: basePrice
              },
              productInfo: {
                sku: $cartItem.attr('data-product-id'),
                productName: $cartItem.attr('data-product-name').toLowerCase(),
                productCategory: $cartItem.attr('data-category').toLowerCase(),
                manufacturer: isSample ? "" : $cartItem.attr('data-brand').toLowerCase(),
                productType: productType,
                option: {
                  color: $cartItem.attr("data-color").toLowerCase(),
                  price: isRemake ? 0 : optionPrice
                }
              }
            }
          ]
        };

        ddoEventInit(thdAnalyticsEvent);
        self.registerScroll();
        self.updateAffirm();
      };

      // Quantity

      self.changeQuantity = function (vm, event) {
        var isBC = globals.siteId === 3;
        $(".bdc-cart-item-col-total-price").css("opacity", .4);
        var $cartItem = $(event.target).parents('.bdc-cart-item');

        $.post(globals.paths.changeLineItemQuantity, {
          quantity: event.target.value,
          lineItemId: event.target.dataset["lineitemid"]
        }, function (data) {

          self.fireCartUpdateEvent($cartItem, parseInt(event.target.value));

          ko.cleanNode($(".bdc-cart")[0]);
          $(".bdc-cart-wrapper").html(data);
          ko.applyBindings(self, $(".bdc-cart")[0]);
          self.addExpressPayButtons();
          self.updateCartCount();
          if (isBC) {
            window.renderDeadpoolLineItem();
          }
        })
        .then((res) => {
          if(window.pageContextJavascript.bestAvailablePromo){
            self.autoApplyBestPromo(window.pageContextJavascript.bestAvailablePromo);
          }
        });
      };

      function debounce(func, delay) {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
      }

      const UpdateQuantity = debounce(cartLineItemQuantityChange, 500);

      self.QuantityChangeEvent = function(_, e) {
        const event = Array.isArray(e) ? e[1] : e;
        const isBC = globals.siteId === 3;
        const max = globals.isInternalUser ? 500 : 50;
        let increment = 0
        if (event.currentTarget.classList.contains("gcc-qty-btn-plus")) {
          increment = 1;
        } else if (event.currentTarget.classList.contains("gcc-qty-btn-minus")) {
          increment = -1;
        }
        let $lineItem = $(event.target).parents('.bdc-cart-item');
        let $input = $(event.target).closest(".qty-input-container").find("input");
        let val = parseInt($input.val());
        let total = val + increment;
        // make sure we are within range of acceptable values
        total = total > max ? max : total;
        total = total < 1 ? 1 : total;
        $input.val(total);
        UpdateQuantity(total, $lineItem, isBC);
      }

      function cartLineItemQuantityChange(total, $lineItem, isBC){
        let lineItemId = $lineItem.attr("data-line-item-id");
        $.post(globals.paths.changeLineItemQuantity, {
          quantity: total,
          lineItemId
        }, function (data) {

          self.fireCartUpdateEvent($lineItem, total);

          ko.cleanNode($(".bdc-cart")[0]);
          $(".bdc-cart-wrapper").html(data);
          ko.applyBindings(self, $(".bdc-cart")[0]);
          self.addExpressPayButtons();
          self.updateCartCount();
          if (isBC) {
            window.renderDeadpoolLineItem();
          }
        })
        .then((res) => {
          if(window.pageContextJavascript.bestAvailablePromo){
            self.autoApplyBestPromo(window.pageContextJavascript.bestAvailablePromo);
          }
        });
      }

      self.proceedToCheckout = function (isCheckout = true) {
        $("#bdc-spinner-checkout").show();
        self.isSubmitting(true);
        $.post(globals.paths.checkSiteProductAvailability, function (data) {
          var updatedCartItems = $(data).find(".bdc-cart-item");
          var inactiveSiteProducts = {
            lineItemValidations: [...new Set($.map(updatedCartItems, function (lineItem) {
              return $(lineItem).attr("data-is-valid");
            }))]
          };
          if (!inactiveSiteProducts.lineItemValidations.includes('False') && isCheckout) {
            const thdAnalyticsEvent = {
              category: {
                primaryCategory: 'button submission',
              },
              eventInfo: {
                eventName: 'cart checkout',
              },
            };
            // send event object for processing
            window.ddoEventInit(thdAnalyticsEvent);
            var useDelorean = globals.siteId === 3;
            var internalUser = Cookies.get("internalUser");
            // var shouldSeePreCheckout = !globals.isAuthenticated && useDelorean && !internalUser && globals.siteId === 3;
            // var path = shouldSeePreCheckout ? '/Ordering/Checkout/Signin' : globals.paths.checkout;
            setTimeout(() => { window.location = globals.paths.checkout; }, 500);
          } else {
            ko.cleanNode($(".bdc-cart")[0]);
            $(".bdc-cart-wrapper").html(data);
            ko.applyBindings(self, $(".bdc-cart")[0]);
            self.addExpressPayButtons();
            self.updateCartCount();
            if (globals.siteId === 3) {
              window.renderDeadpoolLineItem();
            }
          }
        })
        .fail(() => {
          $("#bdc-spinner-checkout").hide();
          self.isSubmitting(false);
        });
      };

      self.toggleShowCost = function () {
        self.showCosts(!self.showCosts());
      }

      self.toggleUnitPrice = function () {
        self.hideUnitPrice(!self.hideUnitPrice());
      }

      function removeLineItems(lineItems) {
        $(".bdc-spinner").show();
        $('body').addClass('loading');
        $(".bdc-content-container").css("opacity", .4);
        $('#gcc-cart-items').css("opacity", .4);
        var lineItemIds = $.map(lineItems, function (lineItem) {
          return $(lineItem).attr("data-line-item-id");
        });

        return $.post(globals.paths.removeLineItem, {
          lineItemIds: lineItemIds
        }, function (data) {
          $('body').removeClass('loading');
          $.each(lineItems, function (index, cartItem) {
            self.fireCartUpdateEvent($(cartItem), 0);
          });

          if (data === "") {
            window.location.href = "/Ordering/Cart";
          } else {
            ko.cleanNode($(".bdc-cart")[0]);
            $(".bdc-cart-wrapper").html(data);
            ko.applyBindings(self, $(".bdc-cart")[0]);
            self.addExpressPayButtons();
            self.updateCartCount();
            self.registerScroll();

            window.renderDeadpoolLineItem();
          }
        })
        .then((res) => {
          if(window.pageContextJavascript.bestAvailablePromo){
            self.autoApplyBestPromo(window.pageContextJavascript.bestAvailablePromo);
          }
        });;
      }

      function onRemoveLineItemClick() {
        var lineItem = $(this).parents(".bdc-cart-item")[0];
        var allLineItems = $(".bdc-cart-item");
        var cartHasInstall = !!document.querySelector("[data-product-id='502797']");
        var cartHasInstallationOnlyInstall = !!document.querySelector("[data-testid*='service-type']");
        const dataProductId = $(lineItem).attr('data-product-id');
        const isMandiEligible = $(lineItem).attr('data-is-mandi-eligible') === "True";
        var lineItemToRemoveIsInstall = dataProductId == self.installProductId;
        var lineItemToRemoveIsMeasure = dataProductId == self.measureProductId;
        const { isDeadpool } = window.pageContextJavascript;

        var allMandiEligibleProductItems = $(allLineItems).filter(itemIndex => {
          const { isMandiEligible } = $($(allLineItems)[itemIndex]).data();
          return isMandiEligible === "True";
        });

        const isLastMandiEligibleProductToRemove = allMandiEligibleProductItems.length === 1 && isMandiEligible;
        const isMeasureOrInstallToRemove = lineItemToRemoveIsMeasure || lineItemToRemoveIsInstall;

        if (cartHasInstall && !cartHasInstallationOnlyInstall && allLineItems.length === 2 && !lineItemToRemoveIsInstall) {
          if (globals.isInternalUser) {
            showOptionNoLongerAvailableModal(allLineItems);
          } else {
            showLookingForInstallationOnlyModal(allLineItems);
          }
        } else if (isDeadpool && isMeasureOrInstallToRemove) {
          showRemoveDeadpoolItemsModal(lineItem, false);
        } else if (isDeadpool && isLastMandiEligibleProductToRemove) {
          showRemoveDeadpoolItemsModal(lineItem, true);
        } else {
          showRemoveItemModal(lineItem);
        }
      }

      function showRemoveItemModal(lineItem) {
        new ColorboxConfirm({
          title: "Remove Item",
          msg: "Are you sure you would like to remove this item from your cart?",
          cssClass: "bdc-colorbox-confirm-deletion",
          buttons: {
            ok: {
              text: "Yes"
            },
            cancel: {
              text: "Cancel"
            }
          }
        }, function () {
          removeLineItems([lineItem]);
        });
      }

      function showRemoveDeadpoolItemsModal(lineItem, isLastMandiEligibleProduct) {
        var allLineItems = $(".bdc-cart-item");
        var $removableMandiServiceItems = $(allLineItems).filter(itemIndex => {
          const { productId } = $($(allLineItems)[itemIndex]).data();
          return productId === self.measureProductId || productId === self.installProductId;
        });

        var removableItems = $removableMandiServiceItems;
        var message = "Removing one of the bundled service items from your cart will remove all related Professional Installation service items.";

        if (isLastMandiEligibleProduct) {
          removableItems = $.merge([lineItem], $removableMandiServiceItems);
          message = "This product is the only product eligible for professional measure and install. Removing it will remove this service.";
        }

        new ColorboxConfirm({
          title: "Are you sure you want to remove?",
          msg: message,
          cssClass: "bdc-colorbox-confirm-deletion",
          buttons: {
            ok: {
              text: "Remove"
            },
            cancel: {
              text: "Cancel"
            }
          }
        }, function () {
          removeLineItems(removableItems);
        });
      }

      function showLookingForInstallationOnlyModal(allLineItems) {
        new ColorboxConfirm({
          title: "Looking for installation only?",
          msg: `If you want to order only the Installation service, please call us at ${window.globalConfig.contactNumber} and we'll be glad to help you`,
          cssClass: "bdc-colorbox-confirm-deletion",
          buttons: {
            ok: {
              text: "Continue Shopping"
            },
            cancel: {
              text: "Empty Cart"
            }
          }
        }, null, function () {
          removeLineItems(allLineItems);
        });
      };

      function showOptionNoLongerAvailableModal(allLineItems) {
        new ColorboxConfirm({
          title: "Option no longer available",
          msg: `If you want to order only installation for the customer, please use the Installation-Only Feature available in the M&I experience`,
          cssClass: "bdc-colorbox-confirm-deletion",
          buttons: {
            ok: {
              text: "Close"
            },
            cancel: {
              text: "Empty Cart"
            }
          }
        }, null, function () {
          removeLineItems(allLineItems);
        });
      };

      function onRemoveSelectedLineItemsClick(lineItemId) {
        var $selected = $(".bdc-cart-item-select-col input[type=checkbox]:checked");
        var itemsSelected = $selected.length;
        var $cartItems = $selected.parents(".bdc-cart-item");
        var allLineItems = $(".bdc-cart-item");

        var cartHasInstall = !!document.querySelector("[data-product-id='502797']");
        var cartHasInstallationOnlyInstall = !!document.querySelector("[data-testid*='service-type']");
        var lineItemsToRemoveHasInstall = $cartItems.filter("[data-product-id=" + self.installProductId + "]").length;
        var lineItemsToRemoveHasMeasure = $cartItems.filter("[data-product-id=" + self.measureProductId + "]").length;
        const { isDeadpool } = window.pageContextJavascript;

        var selectedMandiEligibleProductItems = $cartItems.filter(itemIndex => {
          const { isMandiEligible } = $($($cartItems)[itemIndex]).data();
          return isMandiEligible === "True";
        });

        var allMandiEligibleProductItems = $(allLineItems).filter(itemIndex => {
          const { isMandiEligible } = $($(allLineItems)[itemIndex]).data();
          return isMandiEligible === "True";
        });

        const allMandiEligibleProductsToRemove = selectedMandiEligibleProductItems.length === allMandiEligibleProductItems.length && selectedMandiEligibleProductItems.length > 0;

        if (cartHasInstall && !cartHasInstallationOnlyInstall && itemsSelected == allLineItems.length - 1 && !lineItemsToRemoveHasInstall) {
          if (globals.isInternalUser) {
            showOptionNoLongerAvailableModal(allLineItems);
          } else {
            showLookingForInstallationOnlyModal(allLineItems);
          }
        } else if (isDeadpool && (lineItemsToRemoveHasMeasure !== lineItemsToRemoveHasInstall)) {
          // removing measure should also remove install since its a bundled service(deadpool).
          showRemoveDeadpoolSelectedLineItemsModal(itemsSelected, $cartItems, allLineItems, false);
        } else if (isDeadpool && !lineItemsToRemoveHasMeasure && !lineItemsToRemoveHasInstall && allMandiEligibleProductsToRemove) {
          //removing last eligible mandi product when measure and install services are in the cart.
          showRemoveDeadpoolSelectedLineItemsModal(itemsSelected, $cartItems, allLineItems, true);
        } else {
          showRemoveSelectedLineItemsModal(itemsSelected, $cartItems);
        }
      };

      function removeLineItemsForEdit(lineItems, estimatebuilderUrl) {
        $(".bdc-spinner").show();
        $('body').addClass('loading');
        $(".bdc-content-container").css("opacity", .4);
        $('#gcc-cart-items').css("opacity", .4);
        var lineItemIds = $.map(lineItems, function (lineItem) {
          return $(lineItem).attr("data-line-item-id");
        });

        $.post(globals.paths.removeLineItem, {
          lineItemIds: lineItemIds
        }, function (data) {
          $('body').removeClass('loading');
          $.each(lineItems, function (index, cartItem) {
            self.fireCartUpdateEvent($(cartItem), 0);
          });

          if (data === "") {
            window.location.href = estimatebuilderUrl;
          }
        });
      }

      function onEditInstallProductClick() {
        //Remove is needed to re-add install
        var parentJobId = $(this).attr("data-parent-job-id");
        var $selected = $(".bdc-cart-item-select-col input[type=checkbox]");
        var $cartItems = $selected.parents(".bdc-cart-item");
        var ebUrl = `/estimatebuilder/${parentJobId}`;
        removeLineItemsForEdit($cartItems, ebUrl)
      }

      function showRemoveSelectedLineItemsModal(itemsSelected, $cartItems) {
        var message = "Are you sure you would like to remove these " + itemsSelected + " items from your cart?";

        var colorboxConfirm = new ColorboxConfirm({
          title: "Remove Items",
          msg: message,
          cssClass: "bdc-colorbox-confirm-deletion",
          buttons: {
            ok: {
              text: "Yes"
            },
            cancel: {
              text: "Cancel"
            }
          }
        }, function () {
          removeLineItems($cartItems);
        });
      };

      function showRemoveDeadpoolSelectedLineItemsModal(itemsSelected, $cartItems, allLineItems, lastMandiEligibleProduct) {
        var $removableProductItems = $cartItems.filter(itemIndex => {
          const { productId } = $($($cartItems)[itemIndex]).data();
          return productId != self.measureProductId && productId != self.installProductId;
        });

        var $removableMandiServiceItems = $(allLineItems).filter(itemIndex => {
          const { productId } = $($(allLineItems)[itemIndex]).data();
          return productId === self.measureProductId || productId === self.installProductId;
        });

        var $removalbleItems = $.merge($removableProductItems, $removableMandiServiceItems);

        var titleMsg = "Are you sure you would like to remove these " + itemsSelected + " items from your cart?";
        var message = "Removing one of the bundled service items from your cart will remove all related Professional Installation service items.";

        if (lastMandiEligibleProduct) {
          titleMsg = "Are you sure you want to remove?";
          message = "This product is the only product eligible for professional measure and install. Removing it will remove this service.";
        }

        var colorboxConfirm = new ColorboxConfirm({
          title: titleMsg,
          msg: message,
          cssClass: "bdc-colorbox-confirm-deletion",
          buttons: {
            ok: {
              text: "Remove"
            },
            cancel: {
              text: "Cancel"
            }
          }
        }, function () {
          removeLineItems($removalbleItems);
        });
      };

      $(".bdc-cart-wrapper").on("click", ".bdc-cart-item-btn-remove-item", onRemoveLineItemClick);
      $(".bdc-cart-wrapper").on("click", "#gcc-cart-remove-items", onRemoveSelectedLineItemsClick);
      $(".bdc-cart-wrapper").on("click", "#gcc-cart-edit-install", onEditInstallProductClick);

      self.updateCartCount = function () {
        var cartCount = 0;
        $(".bdc-cart-item").each(function () {
          cartCount += $(this).data("quantity");
        });
        $("[data-testid='header-cart-count']").text(cartCount);
        $("[data-cart-count]").attr("data-cart-count", cartCount);
      };

      self.showLearnMore = function () {
        self.shouldShowLearnMore(true);
      };

      self.toggleSelectAll = function (data, event) {
        $(".bdc-cart-item-select-col input[type=checkbox]").prop("checked", $(event.target).prop("checked"));

        self.selectedLineItems([]);

        if ($(event.target).prop("checked")) {
          $(".bdc-cart-item-select-col input[type=checkbox]").each(function (index, input) {
            self.selectedLineItems.push($(input).val());
          });
        }
      };

      self.toggleStatisfactionGuarantee = function () {
        self.hideStatisfactionGuarantee(!self.hideStatisfactionGuarantee());
      };


      self.saveYourCart = function (vm, event) {
        if (globals.isAuthenticated || globals.isInternalUser) {
          doSave(event);
        }
        else {
          dispatchRequestForLogin();
        };
      };

      self.toggleExpandAll = function (data, event) {
        event.preventDefault();
        event.stopPropagation();
        var isCollapsed = event.target.getAttribute("data-collapsed") === "true";

        $(".accordion-header").each(function (index, element) {
          self.toggleExpand(data, element, isCollapsed);
        });

        event.target.setAttribute("data-collapsed", !isCollapsed);
        event.target.textContent = !isCollapsed ? "Expand All Details" : "Collapse All Details";
      };

      self.toggleExpand = function (data, event, globalToggleState) {
        var isHtml = event instanceof HTMLElement;

        if (!isHtml) {
          event.preventDefault();
          event.stopPropagation();
        }

        var accordionHeader = isHtml ? event : event.target.parentElement;
        var accordionContent = accordionHeader.nextElementSibling;

        if (accordionContent == null) {
          // User clicked on parent header element
          accordionHeader = accordionHeader.firstElementChild;
          accordionContent = accordionHeader.nextElementSibling;
         }

        const hasDisplayBlock = accordionContent.classList.contains("db");

        if (globalToggleState !== undefined && Boolean(globalToggleState) === hasDisplayBlock) {
          // If the global toggle state is true and the current state is also true, we don't need to do anything
          return;
        }

        if(hasDisplayBlock) {
          accordionContent.classList.remove("db");
          accordionContent.classList.add("dn");
          accordionHeader.querySelector(".collapse-icon").classList.remove("db");
          accordionHeader.querySelector(".collapse-icon").classList.add("dn");
          accordionHeader.querySelector(".expand-icon").classList.add("db");
        } else {
          accordionContent.classList.remove("dn");
          accordionContent.classList.add("db");

          accordionHeader.querySelector(".expand-icon").classList.remove("db");
          accordionHeader.querySelector(".expand-icon").classList.add("dn");
          accordionHeader.querySelector(".collapse-icon").classList.add("db");
        }

        if (globalToggleState === undefined) {
          // Updating the global header text based on the current state of all children elements
          changeGlobalExpandText();
        }
      };

      function changeGlobalExpandText() {
        // Since we have two instances of the detailed summary, we need to check which one is being used
        // and set the classQueryString accordingly.
        var classQueryString = ".gcc-detail-summary .accordion-content";

        if (!self.isDesktop()) {
          classQueryString = ".gcc-detail-summary-mobile .accordion-content";
        }

        var availableExpandTargets = document.querySelectorAll(classQueryString).length;
        var actualExpandedTargets = document.querySelectorAll(`${classQueryString}.db`).length;
        var actualCollapsedTargets = document.querySelectorAll(`${classQueryString}.dn`).length;

        var expandElement = document.getElementById("gcc-expand-all-details");

        if (availableExpandTargets === actualExpandedTargets) {
          expandElement.setAttribute("data-collapsed", false);
          expandElement.textContent = "Collapse All Details";
        } else if (availableExpandTargets === actualCollapsedTargets) {
          expandElement.setAttribute("data-collapsed", true);
          expandElement.textContent = "Expand All Details";
        }

        // Commenting out the below code since it is not needed for now.
        // We will do a follow up in conjunction with the design builder and after getting feedback from users.

        // else if (actualCollapsedTargets < actualExpandedTargets && actualExpandedTargets > (availableExpandTargets / 2)) {
        //   expandElement.setAttribute("data-collapsed", false);
        //   expandElement.textContent = "Collapse All Details";
        // } else if (actualCollapsedTargets > actualExpandedTargets && actualCollapsedTargets > (availableExpandTargets / 2)) {
        //   expandElement.setAttribute("data-collapsed", true);
        //   expandElement.textContent = "Expand All Details";
        // } else if (actualCollapsedTargets > actualExpandedTargets) {
        //   expandElement.setAttribute("data-collapsed", false);
        //   expandElement.textContent = "Expand All Details";
        // }
      };

      function dispatchRequestForLogin() {
        var loginEvent = new CustomEvent('loginRequested', {
          detail: {
            taskName: 'SaveCartAsEstimate',
            caller: 'mixedCartModel',
            redirectAfterCreate: false
          }
        });
        document.dispatchEvent(loginEvent);
        document.addEventListener('loginStatusChange', (e) => onLoginStatusChange(e));
        return false;
      };

      function onLoginStatusChange(e) {
        document.removeEventListener('loginStatusChange', (e) => onLoginStatusChange(e))
        globals.isAuthenticated = e.detail.isLoggedIn;
        if (e.detail.caller === 'mixedCartModel' && e.detail.isLoggedIn) {
          doSave();
        }
        return false;
      };

      function doSave(event) {
        if (globals.hasSamples) {
          displaySaveYourCartConfirmation(event);
        } else {
          submitFormToSaveForLater(event);
        };
      }

      function displaySaveYourCartConfirmation(event) {
        var confirmSettings = buildSaveYourCartConfirmSettings();
        var saveCartConfirm = new ColorboxConfirm(confirmSettings,
          function () {
            $(".bdc-spinner").show();
            submitFormToSaveForLater(event);
          },
          function () {
            return false;
          });

        $('#cboxLoadedContent').css({ 'width': '455px', 'height': '175px' });
        $('#cboxContent').css('height', '175px')
      }

      function buildSaveYourCartConfirmSettings() {
        return {
          title: "Save your cart",
          msg: 'Please note that sample swatches will not be saved.',
          cssClass: "bdc-colorbox-confirm-deletion",
          buttons: {
            ok: { text: "I understand, please save this cart" },
            cancel: { text: "Cancel" }
          }
        };
      };

      function submitFormToSaveForLater(event) {
        if (event) {
          $(event.target).closest('form').submit()
        } else {
          window.location.href = globals.paths.saveForLater;
        }
      };

      // Enable 'Show More' and 'Show Less' buttons for measure cart line items
      function onShowMoreDetailsClick() {
        let currentButton = $(this);
        let detailsToShow = currentButton.next();
        let hideDetailsButton = detailsToShow.next();

        currentButton.hide();
        detailsToShow.show();
        hideDetailsButton.show();
      }

      function onShowLessDetailsClick() {
        let currentButton = $(this);
        let detailsToHide = currentButton.prev();
        let showDetailsButton = detailsToHide.prev();

        currentButton.hide();
        detailsToHide.hide();
        showDetailsButton.show();
      }

      $(document).on("click", "[id^='cart-item-show-more-']", onShowMoreDetailsClick);
      $(document).on("click", "[id^='cart-item-show-less-']", onShowLessDetailsClick);

      document.addEventListener("DOMContentLoaded", function () {
        if (globals.siteId === 3) {
          const firstSliceMobileContent = document.getElementById("small-sg-firstSlice-moreInfo");
          const firstSliceMobileToggle = document.getElementById("small-toggle-sg-firstSlice-moreInfo");
          const firstSliceContent = document.getElementById("notSmall-sg-firstSlice-moreInfo");
          const firstSliceToggle = document.getElementById("notSmall-toggle-sg-firstSlice-moreInfo");

          // Safety check to avoid errors if the elements aren't found
          if (!firstSliceMobileContent || !firstSliceMobileToggle || !firstSliceContent || !firstSliceToggle) return;

          let expandedMobile = false;
          let expanded = false;

          firstSliceMobileToggle.addEventListener("click", function () {
            expandedMobile = !expandedMobile;

            if (expandedMobile) {
              firstSliceMobileContent.classList.remove("dn");
              firstSliceMobileContent.classList.add("db");
              firstSliceMobileToggle.textContent = "Show Less";
            } else {
              firstSliceMobileContent.classList.remove("db");
              firstSliceMobileContent.classList.add("dn");
              firstSliceMobileToggle.textContent = "Show More";
            }
          });
          firstSliceToggle.addEventListener("click", function () {
            expanded = !expanded;

            if (expanded) {
              firstSliceContent.classList.remove("dn");
              firstSliceContent.classList.add("db");
              firstSliceToggle.textContent = "Show Less";
            } else {
              firstSliceContent.classList.remove("db");
              firstSliceContent.classList.add("dn");
              firstSliceToggle.textContent = "Show More";
            }
          });
        }
      });

      document.addEventListener("DOMContentLoaded", function () {
        if (globals.siteId === 3) {
          const secondSliceMobileContent = document.getElementById("small-sg-secondSlice-moreInfo");
          const secondSliceMobileToggle = document.getElementById("small-toggle-sg-secondSlice-moreInfo");
          const secondSliceContent = document.getElementById("notSmall-sg-secondSlice-moreInfo");
          const secondSliceToggle = document.getElementById("notSmall-toggle-sg-secondSlice-moreInfo");

          // Safety check to avoid errors if the elements aren't found
          if (!secondSliceMobileContent || !secondSliceMobileToggle || !secondSliceContent || !secondSliceToggle) return;

          let expandedMobile = false;
          let expanded = false;

          secondSliceMobileToggle.addEventListener("click", function () {
            expandedMobile = !expandedMobile;

            if (expandedMobile) {
              secondSliceMobileContent.classList.remove("dn");
              secondSliceMobileContent.classList.add("db");
              secondSliceMobileToggle.textContent = "Show Less";
            } else {
              secondSliceMobileContent.classList.remove("db");
              secondSliceMobileContent.classList.add("dn");
              secondSliceMobileToggle.textContent = "Show More";
            }
          });

          secondSliceToggle.addEventListener("click", function () {
            expanded = !expanded;

            if (expanded) {
              secondSliceContent.classList.remove("dn");
              secondSliceContent.classList.add("db");
              secondSliceToggle.textContent = "Show Less";
            } else {
              secondSliceContent.classList.remove("db");
              secondSliceContent.classList.add("dn");
              secondSliceToggle.textContent = "Show More";
            }
          });
        }
      });
    }

  });
